import { render, staticRenderFns } from "./vue-simplemde.vue?vue&type=template&id=037e8acd&"
import script from "./vue-simplemde.vue?vue&type=script&lang=js&"
export * from "./vue-simplemde.vue?vue&type=script&lang=js&"
import style0 from "./vue-simplemde.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports